module.exports = __webpack_public_path__ + "static/media/mergephone.f1d1488d.gif";